import ApplicationController from "@/controllers/application_controller";

export default class extends ApplicationController {
  initialize(){
    console.log('[Shared::Modal::ComponentController::init]', true)
  }
  connect(){
    console.log('[Shared::Modal::ComponentController::connect]', true)
  }
}